import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
export default mutatorAction('toggleConfettiOption', function (isConfettiEnabled) {
    var optionState = getStore();
    optionState.isEnabled = isConfettiEnabled;
});
//# sourceMappingURL=toggleConfettiOption.js.map